import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from '@/App';
import '@/styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      // Kiosk-wifi hajlamos pár másodperces kimaradásokra — visszapróbálkozás
      // exponenciális backoff-fal, és automatikus frissítés, ha visszajön a net.
      retry: 3,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
      refetchOnReconnect: true,
    },
  },
});

// Kiosk-védelem: a jobb klikk (kontextusmenü) letiltva, hogy a látogató ne tudjon
// "Nézet forráskódja" / "Mentés másként" / böngésző-navigáció útján kilépni a kiosk felületről.
document.addEventListener('contextmenu', (e) => e.preventDefault());

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Nem található a #root elem.');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
